import { render, staticRenderFns } from "./SettingsTab.vue?vue&type=template&id=78dd7982&"
import script from "./SettingsTab.vue?vue&type=script&lang=ts&"
export * from "./SettingsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports